import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-04/lesson-02/task-01";

const task: Slide = {
  title: `Give the value of I (in Ampere).`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/02/task/task-1-item-1.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
